import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import { useAuthStore } from './stores/auth'
import './styles/main.css'

const app = createApp(App)
const pinia = createPinia()

// 1. Register Pinia first (required for auth store)
app.use(pinia)

// 2. Initialize auth store BEFORE registering router
// This ensures router guard has access to authentication state
const auth = useAuthStore()

// 3. Wait for auth initialization, then register router and mount
auth.fetchCurrentUser()
  .catch(() => {
    // Not authenticated - router guard will handle redirect
    console.debug('No active session on app startup')
  })
  .finally(() => {
    // 4. Register router AFTER auth state is initialized
    // This prevents router guard from running before auth is ready
    app.use(router)

    // 5. Mount app after router is registered
    app.mount('#app')
  })
